import React, { useContext } from 'react';
import { CModal, CModalBody, CModalFooter, CModalHeader } from '@coreui/react';
import { Job } from '../../shared/models/jobs';
import JobsDetailsContainer from './JobsDetailsContainer';
import JobActions from '../../jobs/components/JobActions';
import { ConfigContext } from '../../shared/contexts/journeyConfig.context';


interface JobDetailsModalProps {
  isOpen: boolean;
  onToggle: (state: boolean) => void;
  job: Job;
}

const JobDetailsModal = (props: JobDetailsModalProps) => {
  const { isOpen, onToggle, job } = props;
  const labels = useContext(ConfigContext);

  const toggle = () => {
    onToggle(!isOpen);
  }

  return isOpen &&
    <CModal
      show={isOpen}
      onClose={toggle}
    >
      <CModalHeader closeButton>{labels.task} Details</CModalHeader>
      <CModalBody>
        <JobsDetailsContainer job={job} />
      </CModalBody>
      <CModalFooter>
        <JobActions job={ job } />
      </CModalFooter>
    </CModal>;
};

export default JobDetailsModal;
